module.exports = __webpack_public_path__ + "static/media/umn.461a4eaf.png";